import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { CompanyCategory } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<CompanyCategory.Basic>> =>
	Http.get(baseUrl, { params })

export const downloadOverviewDocument = (): Promise<ArrayBuffer> =>
	Http.get(`${baseUrl}/overview-document/download`, {
		responseType: 'arraybuffer'
	})
